export default __webpack_public_path__ + "static/media/card.ffb7ca56.svg";